import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartOverlayComponent } from './start-overlay.component';
import { WelcomeOverlayModule } from '@overlays/welcome-overlay/welcome-overlay.module';
import { HarmonizedShapesModule } from '../harmonized-shapes/harmonized-shapes.module';

@NgModule({
  imports: [CommonModule, WelcomeOverlayModule, HarmonizedShapesModule, StartOverlayComponent],
  exports: [StartOverlayComponent],
})
export class StartOverlayModule {}
